import * as React from 'react';

import { StateContainer } from './StateContainer';

export interface IValueSettingsColProps {
    container: StateContainer;
}

export interface IValueSettingsColState {
    valueIndex?: any;
}

export default class ValueSettingsCol extends React.Component<IValueSettingsColProps, IValueSettingsColState> {
    public constructor(props: IValueSettingsColProps) {
        super(props);
    }

    public render() {
        const { container } = this.props;
        return <div />;
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Vouchers/VoucherDetail/ValueSettingsCol.tsx